export default {
  aboutCrossingPolishBorder: "O przekroczeniu granicy Polski",
  aboutDeviceSwitchToAnotherCar: "O przełożeniu urządzenia do innego auta",
  aboutFuelDrain: "O spuszczeniu paliwa",
  aboutFuelReserve: "O rezerwie paliwa",
  aboutInsurance: "O ubezpieczeniu",
  aboutLongDisconnections: "O długich rozłączeniach typu online",
  aboutLongLayovers: "O zbyt długich przestojach",
  aboutPoolZoneCrossing: "O przekroczeniach rejonizacji podczas użyczenia pool",
  aboutServiceInspection: "O przeglądzie serwisowym",
  aboutSpeedOverLimit: "O przekroczeniu prędkości",
  aboutTechnicalInspection: "O przeglądzie technicznym",
  aboutTireChange: "O wymianie opon",
  aboutToLongLayover: "O zbyt długim postoju",
  aboutUnauthorizedEngineEngage: "O nieautoryzowanym uruchomieniu samochodu",
  aboutZoneCrossing: "O przekroczeniach rejonizacji",
  above7Days: "Powyżej 7 dni",
  accessToGroups: "Dostęp do grup",
  accrualPeriod: "Okres naliczania",
  add: "Dodaj",
  addAdressEmail: "Wpisz email",
  addClient: "Dodaj klienta",
  addDriver: "Dodaj kierowcę",
  addFreeDay: "Dodaj dzień wolny",
  addGroup: "Dodaj grupę",
  addHoliday: "Dodaj święto",
  addPoi: "Dodaj POI",
  addPool: "Dodaj pool",
  addPricing: "Dodaj cennik",
  addRent: "Dodaj wynajem",
  address: "Adres",
  addressPlaceholder: "Ulica, 00-000 Miasto",
  addressReveal: "Odkryj adres",
  addUser: "Dodaj użytkownika",
  administratorPanel: "Panel Administratora",
  alerts: "Alerty",
  alertsAndNotifications: "Powiadomienia i alarmy",
  all: "Wszystkie",
  allCars: "Wszystkie samochody",
  allDrivers: "Wszyscy kierowcy",
  allPoiHasBeenDeleted: "Usunięto wszystkie punky POI",
  april: "Kwiecień",
  areYouSure: "Czy na pewno chcesz",
  assignCars: "Przydziel samochody",
  assignedPricingToCar: "Przypisano cennik do samochodu",
  assignDrivers: "Przydziel kierowców",
  assignToCarsInGroup: "Przypisz dla innych samochodów",
  august: "Sierpień",
  authorityissuingTheDrivingLicense: "Organ wydający prawo jazdy",
  automatic: "Automatyczne",
  automaticDivisionOfPools: "Automatyczne dzielenie pooli",
  automaticReportHasBeenRemoved: "Usunięto raport automatyczny",
  automaticReportInCycle: "Raport automatyczny w cyklu",
  automaticReports: "Raporty automatyczne",
  average: "Średnia",
  average2: "Średni",
  average3: "Średnie",
  averageEcoGrade: "Średnia ocena ECO",
  averageMonthlyCombustionForFleet: "Średnie spalanie floty",
  averageDailyMileageForFleet: "Średni dzienny przebieg floty",
  averageDriveTime: "Średni dzienny czas jazdy",
  averageRouteSpeed: "Średnia prędkość w trasie",
  averageSpeed: "Średnia prędkość",
  backToDefaults: "Przywróć domyślne",
  batteryCondition: "Stan akumulatora",
  batteryLevel: "Stan baterii",
  battery: "baterii",
  bestCars: "najlepsze auta",
  blockade: "Blokada",
  blockedMode: "Tryb blokady",
  blockedUser: "Dostęp zablokowany",
  blockedModeDescription: "Uniemożliwia autoryzację kierowcy i nie pozwala uruchomić samochodu",
  borderCross: "Przekroczenie granicy",
  przekroczenie_granicy: "Przekroczenie granicy",
  borderCrossExplanation: "Monitorowanie przekroczeń granicy Polski",
  brand: "Marka",
  cancel: "Anuluj",
  cancelDrawing: "Anuluj rysowanie",
  car: "Samochód",
  carDamage: "Uszkodzenia samochodu",
  carDamageHasBeenUpdated: "Zaktualizowano uszkodzenia samochodu",
  carDeviceSettings: "Ustawienia urządzenia samochodu",
  carParameters: "Parametry samochodu",
  carEvidencesButtonLabel: "Ewidencja samochodu",
  carEvidencesStartLabel: "Data rozpoczęcia ewidencji",
  carEvidencesEndLabel: "Data zakończenia ewidencji",
  carEvidencesChangedSuccessfully: "Zmiana okresu ewidencji zakończona",
  evidenceClearPeriod: "Zeruj okres prowadzenia ewidencji",
  carParametersHasBeenUpdated: "Parametry samochodu zaktualizowane",
  carPricing: "Cennik samochodu",
  carRegistrationNumberUnderRepair: "Nr rej auta w naprawie",
  cars: "Samochody",
  carsAddedToGroup: "Auta zostały dodane do grupy",
  carsEcoRating: "Ranking ECO samochodów",
  carsExportFilename: "Samochody.csv",
  carsQuantity: "Liczba aut",
  carSettings: "Ustawienia samochodu",
  carsListInGroup: "Lista samochodów w grupie",
  carsInGroup: "Samochody w grupie",
  carsInServiceBlocked: "Samochody w serwisie/zablokowane",
  carsInServiceMode: "Samochody w trybie serwisowym",
  center: "Wyśrodkuj",
  change: "zmienić",
  changeDate: "zmienić datę",
  changePassword: "Zmień hasło",
  changePasswordExpiration: "Zmień termin ważności",
  changePasswordForThisOperator: "zmienić hasło temu operatorowi",
  changePasswordForThisUser: "zmienić hasło temu użytkownikowi",
  changeTires: "Wymiana opon",
  city: "Miasto",
  clientsName: "Nazwa klienta",
  cleanInside: "Czysty wewnątrz",
  cleanOutside: "Czysty na zewnątrz",
  clear: "Wyczyść",
  clearAllZones: "Wyczyść wszystkie rejony",
  clickAndDragToEdit: "Złap za biały kwadrat na krawędzi rejonu i przeciągnij aby edytować",
  clickCancelToUndo: "Kliknij 'Anuluj' aby cofnąć zmiany",
  clickZoneToDelete: "Kliknij rejon, który chcesz usunąć",
  client: "Klient",
  clientAdded: "Dodano klienta",
  clientDataUpdated: "Zaktualizowano dane klienta",
  clients: "Klienci",
  clientHasBeenRemoved: "Usunięto klienta",
  close: "Zamknij",
  collectingTrophiesInformation: "Gromadzenie informacji o trofeach kierowców",
  collectingTrophiesIsOff: "Zbieranie trofeów jest wyłączone",
  combustionForFleet: "spalanie floty",
  conditionAfterRent: "Stan po zakończeniu wynajmu",
  conditionBeforeRent: "Stan przy rozpoczęciu wynajmu",
  conditions: "Warunki",
  confirm: "Zatwierdź",
  confirmation: "Potwierdzenie",
  confirmChanges: "Zatwierdź zmiany",
  confirmNewPassword: "Potwierdź nowe hasło",
  content_info: "Treść/informacja",
  contractDayCount: "Dzień kontraktu",
  contractedMileageHasBeenUpdated: "Zakontraktowany przebieg zaktualizowany",
  contractEnd: "Koniec kontraktu",
  contractExceededMileage: "Przekroczenie przebiegu kontraktu [km]",
  contractedMileage: "Zakontraktowany przebieg [km]",
  contractedMileageMonitor: "Monitoring zakontraktowanego przebiegu",
  contractedMileageMonitorTitle: "Monitoring zakontraktowanego przebiegu samochodu",
  contractNumber: "Numer umowy",
  contractStart: "Początek kontraktu",
  correctContractMileage: "Poprawny przebieg kontraktu [km]",
  correctAddressEmailInformation: "Wciśnij spację lub enter aby zaakceptować email i dodać go do listy",
  criticalIncident: "Zdarzenie krytyczne",
  criticalIncidents: "Zdarzenia krytyczne",
  currentDate: "Aktualna data",
  currectContractMileage: "Aktualny przebieg kontraktu [km]",
  currentMileageState: "Aktualny stan licznika [km]",
  currently: "Aktualnie",
  currentRoute: "Bieżąca trasa",
  currentRouteFrom: "Pojazd w trasie od",
  customPin: "Inne",
  cycle: "Cykl",
  damageList: "Lista uszkodzeń",
  dashboard: "Dashboard",
  data: "Dane",
  dataTitle: "Dane samochodu",
  date: "Data",
  dateCannotBeAfterFinishDateMessage: "Data nie może być późniejsza niż data zakończenia",
  dateCannotBeBeforeStartDateMessage: "Data nie może być wcześniejsza niż data rozpoczęcia",
  dateCannotBeInTheFutureMessage: "Data nie może wybiegać w przyszłość",
  dateChangeError: "Błąd zapisu daty",
  dateCannotBeEarlierThanMinimumDate: "Data nie może być wcześniejsza niż data minimalna",
  dateCannotBeLaterThanMaximumDate: "Data nie może być późniejsza niż data maksymalna",
  dateFrom: "Data od",
  dateHasBeenUpdated: "Zaktualizowano datę",
  dateOfIssueOfTheDrivingLicense: "Data wydania prawa jazdy",
  dateTo: "Data do",
  dailyMileagePercent: "% przebiegu dziennego",
  day: "dzień",
  days: "dni",
  dayAfter: "dzień po",
  dayBefore: "dzień przed",
  dayOffHasBeenRemoved: "Dzień wolny usunięty",
  daysAfter: "dni po",
  daysBefore: "dni przed",
  daysOffHasBeenAdded: "Dni wolne dodane",
  december: "Grudzień",
  defaultEmails: "Domyślne adresy email",
  defaultEmailsAndPhones: "Domyślne adresy email i numery telefonów",
  defaultSettingsForRents: "Ustawienia domyślne dla wynajmów",
  defaultZonesPoland: "Domyślna rejonizacja: Polska",
  delete: "Usuń",
  deleteAllPoi: "Usuń wszystkie poi",
  deleteAllPoiInformation: "usunąć wszystkie POI",
  deleteClient: "Usuń Klienta",
  deleteDayOffConfirmation: "usunąć ten dzień wolny",
  deleteDriver: "Usuń kierowcę",
  deleteGroup: "Usuń grupę",
  deleteGroupConfirmation: "usunąć tą grupę",
  deleteMovingHolidayConfirmation: "usunąć to ruchome święto",
  deletePoiConfirmation: "usunąć ten POI",
  deletePoolConfirmation: "usunąć ten pool",
  deleteRentConfirmation: "usunąć ten wynajem",
  deletePricing: "Usuń Cennik",
  deleteRegularHolidayConfirmation: "usunąć to regularne święto",
  deleteReport: "usunąć raport",
  deleteReportConfirmation: "usunąć ten raport",
  deleteThisClient: "usunąć tego klienta",
  deleteThisDriver: "usunąć tego kierowcę",
  deleteThisOperator: "usunąć tego operatora",
  deleteThisPricing: "usunąć ten cennik",
  deleteThisUser: "usunąć tego użytkownika",
  deleteUser: "Usuń użytkownika",
  deleteZones: "Usuń rejony",
  description: "Opis",
  deletedSuccessfully: "Element usunięty",
  deselectAllElements: "Odznacz wszystkie elementy",
  details: "Szczegóły",
  detectionBatteryStatus: "Stan akumulatora",
  detectionCarBreakIn: "Włamanie do samochodu",
  deviationFromPreviousPeriod: "Odchył względem poprzedniego okresu",
  device: "Urządzenie",
  deviceDetailsAdditionalInfo1: "Prezentowane dane zostały wysłane do urządzenia, ale nie otrzymano jeszcze potwierdzenia zapisu.",
  deviceDetailsAdditionalInfo2: "Jeśli w ciągu 2 dni o próby zapisu urządzenie nie potwierdzi przyjęcia zmian zostanie wysłane powiadomienie w systemie.",
  devicePhoneNo: "Numer telefonu GPS",
  deviceSettingsDialogInfoText1: "Aktywowanie telefonu do powiadomień spowoduje wysyłanie następujący informacji i alarmów z urządzenia:",
  deviceSettingsDialogInfoText2: "Brak akumulatora",
  deviceSettingsDialogInfoText3: "Włamanie do samochodu",
  deviceSettingsDialogInfoText4: "Spadek napięcia w akumulatorze poniżej 10,5V",
  deviceSettingsDialogInfoText5: "Przekroczenie zdefiniowanej prędkości maksymalnej samochodu (Aktywacja powiadomienia w zakładce Grupy)",
  deviceSettingsHasBeenUpdated: "Ustawienia urządzenia zaktualizowane",
  distance: "Dystans",
  mileage: "Przebieg",
  documents: "Dokumenty",
  doesPhoneNo1Active: "Czy 1. nr tel. jest aktywny:",
  doesPhoneNo2Active: "Czy 2. nr tel. jest aktywny:",
  dontShowAgain: "Nie pokazuj ponownie",
  drawZoneOnMap: "Rysuj rejon na mapie",
  driver: "Kierowca",
  driverEditedSuccessfully: "Dane kierowcy zostały zaktualizowane",
  driverDataNotFound: "Nie znaleziono danych kierowcy",
  driverDeletedSuccessfully: "Kierowca został usunięty",
  driverLicenseNumber: "Nr prawa jazdy",
  driverLog: "Logowanie kierowcy",
  drivers: "Kierowcy",
  driversDoNotMeetTheImportRequirements: "Kierowcy niespełniający wymagań importu",
  driversEcoRating: "Ranking ECO kierowców",
  driversLogs: "Logowanie kierowców",
  driversExportFilename: "kierowcy.csv",
  driveTime: "czas jazdy",
  driveTimeSum: "Suma czasu spędzonego za kierownicą",
  driveType: "Cel podróży",
  driveTypeOutsideZone: "Cel podróży poza rejonem",
  ecoChart: "Wykres ECO",
  ecoGradeForFleet: "Ocena ECO",
  ecoLow: "przebieg floty z niskim ECO",
  ecoMedium: "przebieg floty ze średnim ECO",
  ecoHigh: "przebieg floty z wysokim ECO",
  ecoPeriodLow: "ECO 4.00-0",
  ecoPeriodMedium: "ECO 7.00-4.00",
  ecoPeriodHigh: "ECO 10.00-7.00",
  editDriver: "Edytuj kierowcę",
  editZones: "Edytuj rejony",
  email: "Email",
  emailsAddresses: "Adresy email",
  emailAddressesForReports: "Adresy email do raportów",
  emailsAddressesFromGeneralSettings: "Adresy email - z ustawień ogólnych",
  emailsAddressesFromPrivate: "Adres email - prywatne",
  emailAddressLabel: "Adres email",
  emailList: "Lista email",
  estimatedDailyMileage: "Planowany przebieg dzienny [km]",
  expectedAverageFuelConsumptionECO: "Oczekiwane średnie spalanie (ECO)",
  expectedFuelConsumption: "Oczekiwane spalanie",
  expectedFuelConsumptionShortcut: "OŚZ",
  expectedFuelConsumptionWithUnits: "Oczekiwane średnie zużycie [l/100km]",
  expectedFuelConsumptionForSelectedCarsHasBeenUpdated: "Zaktualizowano oczekiwane zużycie paliwa dla wybranych samochodów",
  exportMap: "Eksportuj mapę",
  exportToFile: "Eksportuj do pliku",
  february: "Luty",
  fileHasBeenAdded: "Plik został dodany",
  fileName: "Nazwa pliku",
  fileUploadError: "Błąd pobierania pliku",
  find: "Wyszukaj",
  finished: "Zakończył",
  finishedDrive: "zakończył jazdę",
  fireExtinguisher: "Gaśnica",
  first: "Pierwsze",
  firstAndLastName: "Imię i nazwisko",
  firstName: "Imię",
  fleetMileage: "przebieg floty",
  forgotPassword: "Nie pamiętam hasła",
  forgotPasswordConfirmation: "Na podany adres email zostały link weryfikujący do resetowania hasła. Proszę sprawdzić skrzynkę email.",
  forUser: "dla użytkownika",
  freeDays: "Dni wolne",
  friday: "Piątek",
  from: "Od",
  from1To3Days: "Od 1 do 3 dni",
  from4to7Days: "Od 4 do 7 dni",
  fromFile: "Z pliku",
  fuel: "Paliwo",
  fuelLevel: "Stan paliwa",
  fuelReserve: "Rezerwa paliwa",
  fuelReserveExplanation: "Monitorowanie rezerwy paliwa",
  fuelType: "Rodzaj paliwa",
  gearBox: "Skrzynia biegów",
  general: "Ogólne",
  generateKey: "Generuj klucz",
  geoCoordinates: "Współrzędne geograficzne",
  gprs: "GPRS",
  gps: "Punkty GPS",
  gpsPoint: "Punkt GPS",
  grade: "Ocena",
  group: "Grupa",
  groupName: "Nazwa grupy",
  groups: "Grupy",
  groupDeletedMsg: "Grupa usunięta",
  groupDetails: "Szczegóły grupy",
  groupsEditedMsg: "Grupa została zaktualizowana",
  groupWithThatNameExists: "Istnieje grupa o takiej nazwie!",
  guidelines: "Wytyczne",
  hideArchived: "Schowaj zarchiwizowane",
  hideInService: "Schowaj auta w serwisie",
  hideNotArchived: "Schowaj niezarchiwizowane",
  hidePoiOnMap: "Ukryj punkty POI",
  home: "Dom",
  hour: "Godz",
  hoursAbbreviation: "h",
  immovableFiests: "Święta regularne",
  import: "Importuj",
  importClientsFromFile: "Importuj z pliku .csv dane klientów",
  importCsvDescriptionCar: "Importuj z pliku .csv dane samochodów do przydzielenia w grupie",
  importCsvDescriptionDriver: "Importuj z pliku .csv dane kierowców do przydzielenia",
  importCsvDescriptionDriverAdd: "Importuj z pliku .csv dane kierowców do dodania",
  importCsvDescriptionFreeDaysTable: "Importuj z pliku .csv dni wolne dla samochodów",
  importCsvDescriptionPOILocations: "Importuj z pliku .csv dane do tabeli POI",
  importFromFile: "Importuj z pliku",
  importTemplate: "Importuj szablon",
  incident: "Zdarzenie",
  incidents: "Zdarzenia",
  incidentDate: "Data zdarzenia",
  incidentInfo: "Informacje o zdarzeniu",
  incorrectEmailFormat: "Nieprawidłowy format email",
  incorrectUserName: "To pole jest wymagane",
  incorrectPasswordFormat: "Hasło nie spełnia wymagań",
  individualEmails: "Indywidualne adresy email",
  individualWorkingHours: "Indywidualne godziny pracy",
  individualWorkingHoursTitle: "Indywidualne godziny pracy dla samochodu",
  info: "Informacja",
  inPeriodFrom: "W okresie od",
  inPeriodTo: "do",
  inServiceTooltip: "Pokaż tylko auta w serwisie",
  inspections: "Przeglądy pojazdu",
  insurance: "Ubezpieczenia",
  insurancePatchSuccessMsg: "Data ubezpieczenia została ustawiona",
  invalidDate: "Niepoprawna data",
  invalidDateFormat: "Niepoprawny format daty",
  invalidFileUploaded: "Przesłano niepoprawny plik",
  invalidTimeFormat: "Niepoprawny format czasu",
  irreversibleActionInformation: "Przed usunięciem, pamiętaj o wyeksportowaniu POI do pliku. Operacja jest nieodwracalna!",
  january: "Styczeń",
  july: "Lipiec",
  june: "Czerwiec",
  keywords: "Słowa kluczowe",
  kilometers: "Kilometry",
  kilometersLimit: "Limit kilometrów",
  kilometersLimitPeriod: "Okres limitu",
  kilometerQuantity: "Ilość kilometrów",
  kilometerQuantityOutsizeZone: "Liczba kilometrów poza rejonem",
  lastActivity: "Ostatnia aktywność",
  lastComm: "Ost. komunikacja",
  lastCommTimestamp: "Czas nawiązania ostatnie komunikacji",
  lastEmailIsIncorrect: "Ostatni adres email jest niepoprawny",
  lastName: "Nazwisko",
  layoverTime: "Czas postoju",
  layoverTimeInHours: "Czas postoju (w godzinach)",
  latitude: "Szerokość",
  legend: "Legenda",
  loadingPDF: "Ładuje PDF...",
  location: "Lokalizacja",
  logInLabel: "Zaloguj",
  logout: "Wyloguj",
  longitude: "Długość",
  lumSum: "Ryczałt",
  lumpSumPln: "Ryczałt (PLN)",
  makingChangeResetsReminderCounter: "zmiana resetuje licznik przypomnień",
  map: "Mapa",
  mapAppbarTitle: "Raportowanie na mapie",
  march: "Marzec",
  max: "Maksymalna",
  maxDateMessage: "Data nie może być późniejsza niż data zakończenia",
  maximumSpeed: "Prędkość maksymalna",
  manage: "Zarządzaj",
  manageUser: "Zarządzaj kontem użytkownika podrzędnego",
  manageUsers: "Konta użytkowników",
  may: "Maj",
  min: "Min.",
  minDateMessage: "Data nie może być wcześniejsza niż data rozpoczęcia",
  minutesAbbreviation: "min",
  measurement: "Pomiar",
  measurements: "Pomiary",
  medkit: "Apteczka",
  meterCountAfter: "Stan licznika po",
  meterCountBefore: "Stan licznika przed",
  meterReading: "Stan licznika",
  monday: "Poniedziałek",
  motorbike: "Motocykl",
  mpr: "MPR",
  mprExplanation: "Monitorowanie przekroczeń rejonizacji",
  mpp: "MPP",
  mppExplanation: "Monitorowanie przekroczeń prędkości",
  mnu: "MNU",
  mnuExplanation: "Monitorowanie nieautoryzowanych uruchomień",
  mprpu: "MPRPU",
  mpruExplanation: "Monitorowanie przekroczeń rejonizacji podczas użyczenia pool",
  mobileAppKey: "Klucz aplikacji mobilnej",
  model: "Model",
  monitoringActive: "Monitorowanie aktywne",
  monitoringNotActive: "Monitorowanie nieaktywne",
  month: "Miesiąc",
  monthly: "miesięczny",
  monthly1: "miesięczne",
  monthlyReportTitle: "Miesięcznych",
  monthOfContract: "Umowa miesiąc",
  movingHolidayHasBeenAdded: "Dodano święto ruchome",
  movingHolidayHasBeenRemoved: "Usunięto święto ruchome",
  movingHolidays: "Święta ruchome",
  name: "Nazwa",
  nameAndSurnameOrBusinessName: "Imię i nazwisko / Nazwa firmy",
  neededPossibilityUploadingFile: "Potrzebna możliwość przesłania pliku",
  newDate: "Nowa data: ",
  newPassword: "Nowe hasło",
  newPasswordMustBeDifferentFromThePreviousOne: "Nowe hasło musi być inne od poprzedniego",
  nextInspectionDate: "Data następnego przeglądu",
  nextInsuranceDate: "Data końca ubezpieczenia",
  nextPage: "Następna strona",
  nip: "Nip",
  noActivity: "Brak aktywności",
  noAssignedCars: "Brak przydzielonych samochodów...",
  noClients: "Brak klientów",
  noDataForSpecifiedCriteria: "Brak wyników dla wybranych w kryteriów",
  noDataInfo: "Brak danych...",
  noDataInSpecifiedTime: "Brak tras w wybranym okresie",
  noDescriptionForTrophy: "Brak opisu dla wybranego trofea",
  noDrivers: "Brak kierowców",
  noEndDate: "Brak daty zakończenia",
  noExpiration: "Bezterminowo",
  noKeywords: "Brak słów kluczowych",
  noPasswordExpirationConfirmationMessage: "dodać użytkownika z bezterminowym hasłem",
  noReportChosen: "Brak wybranego raportu",
  noResultsInfo: "Brak wyników",
  notifications: "Powiadomienia",
  november: "Listopad",
  october: "Październik",
  ok: "OK",
  on: "ON",
  off: "OFF",
  oldPassword: "Stare hasło",
  operator: "Operator",
  operatorAdded: "Dodano operatora",
  operatorDataUpdated: "Zaktualizowano dane operatora",
  operatorLogin: "Login operatora",
  operators: "Operatorzy",
  operatorPasswordHasBeenReset: "Zresetowano hasło operatora",
  operatorHasBeenRemoved: "Operator usunięty",
  orderReport: "Zamówienie raportu",
  ordinalNumber: "L.p.",
  others: "Inne",
  outsizeZone: "Poza rejonem",
  overLimit: "Przekroczenie",
  overLimits: "Przekroczenia",
  overwriteDriver: "Kopiuj dane",
  panicMode: "Tryb panic",
  panicModeDescription: "Uniemożliwia autoryzację kierowcy, nie pozwala uruchomić samochodu i załącza sygnały alarmowe (opcja)",
  passwordLabel: "Hasło",
  passwordExpiration: "Ważność hasła",
  passwordExpirationDateHasBeenChanged: "Termin ważności hasła został zmieniony",
  passwordForSMS: "Hasło dla SMS",
  passwordHasBeenChanged: "Hasło zostało zmienione",
  passwordHasBeenReseted: "Hasło zresetowane",
  passwordRequiredParameters: "Hasło musi zawierać co najmniej 1 znak specjalny, 1 cyfrę, 1 wielką i 1 małą literę oraz być nie krótsze niż 8 znaków.",
  passwordsDoesntMatch: "Nowe hasło i potwierdzenie hasła muszą być identyczne",
  pendingReportHasBeenRemoved: "Usunięto raport oczekujący",
  pendingReports: "Raporty oczekujące",
  percentageOverMileage: "Nadprzebieg procentowo [%]",
  perHour: "Za godzinę",
  permissionsLevel: "Poziom uprawnień",
  peselOrDateOfBirth: "Pesel lub data urodzenia",
  phone: "Telefon",
  phoneNumberForNotifications: "Numer telefonu do powiadomień",
  pick: "Wybierz...",
  pickBrandToDisplayModels: "Wybierz markę, aby wyświetlić dostępne modele",
  pickGroup: "Wybierz grupę",
  pickMapPointAndDraw: "Wybierz punkt na mapie i przeciągnij myszką.",
  pickReport: "Wybór raportu",
  pinCode: "Pin kod",
  place: "Miejscowość",
  poi: "POI",
  poiExportFilename: "POI.csv",
  poolDeletedSuccessfully: "Pool został usunięty",
  poolDivideInterval: "Co ile minut dzielić pool",
  poolManagement: "Zarządzanie poolem",
  poiHasBeenAdded: "Dodano POI",
  poiHasBeenRemoved: "Usunięto POI",
  poiHasBedUpdated: "Zaktualizowano dane POI",
  poolUpdatedSuccessfully: "Zaktualizowano dane Poola",
  possibilityNotSendingSmsInfo: "Samochód jest rozłączony dłużej niż 24 godziny.",
  possibilityNotSendingSmsInfo2: "SMS może nie dotrzeć.",
  possibleMaxSpeed: "Dopuszczalna prędkość maksymalna",
  previousPage: "Poprzednia strona",
  pricing: "Cenniki",
  pricingAdded: "Dodano cennik",
  pricingDataUpdated: "Zaktualizowano dane cennika",
  pricingHasBeenRemoved: "Usunięto cennik",
  privateModeDrive: "Jazda poza godzinami pracy",
  quantity: "Ilość",
  quantityOfDisplayingElements: "Liczba wyświetlanych elementów",
  quarter: "Kwartał",
  quarterly: "kwartalny",
  quarterly1: "kwartalne",
  quarterReportTitle: "Kwartalnych",
  queueNo: "Nr w kolejce",
  radio: "Radio",
  radius: "Promień",
  radiusKm: "Promień (km)",
  rate: "Stawka (PLN)",
  ratePerKilometerAboveLimit: "Stawka za kilometr powyżej limitu",
  ratePerKmAboveLimit: "Stawka za km ponad limit",
  rateAfterLimitExceeded: "Stawka za kilometr po przekroczonym limicie",
  received: "Odebrane",
  refuel: "Tankowanie",
  refuelDate: "Data tankowania",
  refueled: "Zatankowano",
  refuels: "Tankowania",
  registrationNo: "Rejestracja",
  regon: "regon",
  regularHolidayHasBeenAdded: "Dodano święto regularne",
  regularHolidayHasBeenRemoved: "Usunięto regularne święto",
  releaseMouseButton: "Puść przycisk myszki aby zakończyć rysowanie",
  remarks: "Uwagi",
  rememberMe: "Zapamiętaj mnie",
  reminder1: "Przypomnienie 1.",
  reminder2: "Przypomnienie 2.",
  reminder3: "Przypomnienie 3.",
  reminder4: "Przypomnienie 4.",
  reminderMaxAfter: "Przypomnienie maksymalnie po",
  reminderMaxBefore: "Przypomnienie maksymalnie przed",
  reminders: "Przypomnienia",
  rentalChangeRegister: "Rejestr zmian wynajmu",
  rentalManagement: "Zarządzanie Wynajmem",
  rentDeletedSuccessfully: "Wynajem został usunięty",
  rentHasBeedAdded: "Dodano wynajem",
  rented: "Wynajęty",
  rentRequiresServiceOrder: "Wynajem wymaga podania numeru zlecenia serwisowego",
  rents: "Wynajmy",
  rentUpdatedSuccessfully: "Zaktualizowano dane Wynajmu",
  rentingList: "Lista najmów",
  repairEquipment: "Akcesoria naprawcze",
  reportHasBeenAdded: "Dodano raport",
  reportName: "Nazwa raportu",
  reports: "Raporty",
  reportsAndNotificationsForCar: "Raporty i powiadomienia dla samochodu",
  reportSettingsHasBeenUpdated: "Ustawienia raportów zaktualizowane",
  requiredField: "Pole wymagane",
  reqiredFieldsNotFilled: "Wymagane pola nie zostały wypełnione",
  reserve: "Rezerwa",
  resetFilters: "Resetuj filtry",
  resetPassword: "Reset hasła",
  requiredSetKmLimit: "Wymagane podanie limitu km",
  requiredSetStartingHoursAndMinutesOfWorkBeginning: "Wymagane podanie godziny oraz minut rozpoczęcia pracy",
  requiredSpecificationOfTheLengthOfTheStopInHoursAndTheStartAndEndOfWorkingHours: "Wymagane podanie długości postoju w godzinach i rozpoczęcia oraz zakończenia godzin pracy",
  resetView: "Resetuj widok",
  restoredDefaultSetting: "Przywrócono ustawienia domyślne",
  rewriteCustomerDataToDriver: "Przepisz dane klienta do kierowcy",
  rfid: "RFID",
  service: 'Serwis',
  sapid: "SAP ID",
  rfidAlreadyInUse: "Wpisany numer RFID jest już w użyciu",
  rfidHelperText: "RFID zawiera 10 znaków składających się z liter i/lub cyfr",
  rodoAcceptationTitle: "Zgoda RODO",
  rodoAcceptationContent1: "Szanowny Użytkowniku",
  rodoAcceptationContent2: `Aby dalej móc dostarczać usług internetowych świadczonych przez ETS Polska sp. z o.o., potrzebujemy zgody na obsługę danych, które są udostępniane naszej firmie.
    25 maja 2018 roku zacznie obowiązywać Rozporządzenie Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (określane jako „RODO”, „ORODO”, „GDPR” lub „Ogólne Rozporządzenie o Ochronie Danych”).
    W związku z tym chcielibyśmy poinformować o przetwarzaniu danych oraz zasadach, na jakich będzie się to odbywało po dniu 25 maja 2018 roku.
    Poniżej znajdują się podstawowe informacje na ten temat.
    Przetwarzanie udostępnionych nam danych odbywa się wyłącznie zgodnie z POLITYKĄ BEZPIECZEŃSTWA DANYCH OSOBOWYCH, obowiązująca w ETS Polska sp. z o.o.`,
  rodoAcceptationContent3: `1. Dane z którymi ma styczność ETS Polska sp. z o.o.,
    Dane osobowe, z którymi mamy do czynienia są zbierane w ramach korzystania z naszych usług, w tym stron internetowych i innych funkcjonalności udostępnianych przez ETS Polska sp. z o.o., w tym zapisywane w plikach cookies. Administratorami danych osobowych jest ETS Polska sp. z o.o. z siedzibą w Warszawie (dalej „ETS-Polska”).`,
  rodoAcceptationContent4: `2. Powód przetwarzania udostępnionych ETS-Polska danych
    Przetwarzamy te dane wyłącznie na podstawie zawartych umów, w celach opisanych w naszej polityce, między innymi, aby zapewnić komfort i bezpieczeństwo usług, w tym aby wykryć oszustwa czy nadużycia.`,
  rodoAcceptationContent5: `3. Przekazanie danych przez ETS-Polska
    Zgodnie z obowiązującym prawem dane możemy przekazywać podmiotom przetwarzającym je na nasze zlecenie, np. podwykonawcom naszych usług oraz podmiotom uprawnionym do uzyskania danych na podstawie obowiązującego prawa np. sądy lub organy ścigania – oczywiście tylko gdy wystąpią z żądaniem w oparciu o stosowna podstawę prawną.`,
  rodoAcceptationContent6: `4. Podstawy prawne przetwarzania danych przez ETS-Polska
    Każde przetwarzanie danych przez ETS-Polska jest oparte na właściwej, zgodnej z obowiązującymi przepisami, podstawie prawnej. Podstawą prawną przetwarzania danych w celu świadczenia usług przez ETS-Polska jest zawarta umowa, której przedmiotem jest świadczenie naszych usług. Nie przekazujemy danych innym podmiotom, poza wymienionymi w punkcie 3.`,
  rodoAcceptationContent7: `Dlatego też prosimy o zaznaczenie pola „AKCEPTUJĘ”, co oznacza zgodę na przetwarzanie, po 25 maja 2018 roku, danych osobowych zbieranych w ramach korzystania z usług ETS Polska, w tym ze stron internetowych, serwisów i innych funkcjonalności, w tym także zbieranych w tzw. plikach cookies. Wyrażenie zgody jest dobrowolne. Informujemy, że brak wyrażenia zgody oznacza równocześnie brak możliwości korzystania z naszych usług.`,
  rodoAccept: "Akceptuję",
  route: "Trasa",
  routeBegin: "Początek trasy",
  routeDuration: "Okres trwania odcinka",
  routeFinish: "Koniec trasy",
  routeOutsideZone: "Trasa poza rejonem",
  routePartLength: "Długość odcinka",
  routePartLengthWillBeShowAfterEnd: "Długość odcinka zostanie pokazana po zakończeniu trasy",
  routes: "Trasy",
  routesDistanceSum: "Suma długości trasy",
  routesFrom: "Trasy od",
  routesTill: "Trasy do",
  routesDetails: "Szczegóły tras",
  routeFinishAddress: "Adres końca trasy",
  routeListInPeriod: "Lista tras w okresie",
  routeWithoutOverruns: "Odcinek bez przekroczeń",
  saturday: "Sobota",
  save: "Zapisz",
  saveAndClose: "Zapisz i zamknij",
  saveChanges: "Zapisz zmiany",
  savePdfToFile: "Zapisz do pliku (PDF)",
  schedules: "Harmonogramy",
  search: "Szukaj",
  searching: "Wyszukiwanie...",
  searchLastRoutes: "Wyszukaj ostatnie trasy",
  searchWithAddress: "Wyszukaj z adresem",
  second: "Drugie",
  sent: "Wysłane",
  select: "Wybierz",
  selectAll: "Zaznacz wszystkie",
  selectAllElementes: "Zaznacz wszystkie elementy",
  selectClient: "Wybierz Klienta",
  selectDriver: "Wybierz Kierowcę",
  selectElementAndDescribeDamage: "Zaznacz element i opisz uszkodzenie",
  selectFile: "Wybierz plik",
  selectReportBeforeOrderMsg: "Wybierz raport, który ma zostać zamówiony",
  selectReportBeforeImportingTemplateMsg: "Wybierz raport, którego szablon ma zostać pobrany",
  send: "Prześlij",
  sendingMessageToCar: "Wysyłanie SMS do samochodu",
  sendingReports: "Wysyłanie raportów",
  september: "Wrzesień",
  serialNo: "Nr seryjny",
  seriesAndNumberOfTheIdentityCard: "Seria i nr dowodu osobistego",
  serverError: "Błąd serwera.",
  serviceInspections: "Przeglądy serwisowe",
  serviceInspectionsSettings: "Przypomnienia",
  serviceInspectionsPatchSuccessMsg: "Dane dla przeglądu serwisowego zaktualizowane",
  serviceInspectionsPatchErrorMsg: "Bład aktualizacji danych przeglądu serwisowego",
  serviceCarMode: "Tryb pracy",
  serviceMode: "Tryb serwisowy",
  serviceModeDescription: "Wyłącza wszystkie funkcje ochronne systemu i pozwala uruchomić samochód bez autoryzacji kierowcy",
  serviceOrderNumber: "Numer zlecenia serwisowego",
  serviceRemider: "Przypomnienie co",
  nearestServiceRemider: "Najblizsze przypomnienie",
  nearestServiceRemiderWhen: "Najbliższe przypomnienie zostanie wysłane za",
  serviceDateRemider: "Przypomnienie przed dniem",
  setExpectedFuelConsumption: "Ustaw oczekiwane spalanie",
  settings: "Ustawienia",
  settingsHasBeedUpdated: "Zaktualizowano ustawienia",
  shareClientsWithSubordinateUser: "Współdzielenie klientów z użytkownikami podrzędnymi",
  showAdditionalColumnsInReportRecord: "Pokaż dodatkowe kolumny w raporcie ewidencji przebiegu",
  showAdditionalColumnsInReportRecordTooltip: "Data zwrotu samochodu, nr zlecenia, koszt wynajmu",
  showArchived: "Pokaż zarchiwizowane",
  showCarDetails: "Pokaż szczegóły samochodu",
  showEcoChart: "Pokaż wykres ECO",
  showFilters: "Pokaż filtry",
  showNotArchived: "Pokaż niezarchiwizowane",
  showPoiOnMap: "Pokaż punkty POI",
  showOnMap: "Pokaż na mapie",
  showZeroDistance: "Ewidencja przebiegu - czy pokazywać zerowe dystanse",
  sms: "Sms",
  somethingWentWrong: "Coś poszło nie tak...",
  speed: "Prędkość",
  speedMax: "Prędkość maksymalna",
  speedAvr: "Prędkość średnia",
  speedExceededAbove10: "Przekroczenie 10 - 30 km/h",
  speedExceededAbove30: "Przekroczenie > 30 km/h",
  speedExceededAbove50: "Przekroczenie > 50 km/h",
  speedExceededBy: "Prędkość przekroczona o: ",
  speedLimit: "Dopuszczalna prędkość: ",
  speedWhenCrossing: "Prędkość podczas przekroczenia: ",
  startCollectingTrophiesConfirmation: "zacząć gromadzić informacje o trofeach kierowców",
  started: "Rozpoczął",
  state: "Stan",
  status: "Status",
  statusPending: "Oczekiwanie...",
  deviceNotConnected: "Brak połączenia",
  stopCollectingTrophiesConfirmation: "przestać gromadzić informacje o trofeach kierowców",
  streetAndHouseNumber: "Ulica i nr domu",
  streetHouseNumber: "Ulica nr domu",
  successfullyChangedForcedPasswordTitle: "Pomyślnie zmieniono hasło!",
  successfullyChangedForcedPasswordContent: "Hasło zostało zmienione! Kliknij przycisk 'Zamknij' i zaloguj się ponownie",
  subAdmin: "Administrator",
  subUser: "Podstawowy",
  sunday: "Niedziela",
  targetPlace: "Miejsce docelowe",
  technicalInspections: "Przeglądy techniczne",
  technicalInspectionsPatchSuccessMsg: "Data przeglądu technicznego zaktualizowana",
  template: "Szablon.csv",
  temporaryUser: "Tymczasowy",
  thursday: "Czwartek",
  themeChange: "Zmiana motywu",
  timeBeforeSendingOfflineNotification1: `Czas rozłączenia urządzeń typu online,`,
  timeBeforeSendingOfflineNotification2: " po którym ma nastąpić powiadomienie",
  timeBehindTheWheel: "Czas za kierownicą",
  timeOutsideTheZone: "Czas poza rejonem",
  to: "Do",
  toExpectedFuelConsumption: "do oczekiwanego spalania paliwa",
  toGeneralEmailAddress: "Na email z ustawień domyślnych",
  toGroup: "do grupy",
  tools: "Narzędzia",
  top: "Najlepsze",
  toPrivateEmailAddress: "Na email prywatny",
  toReport: "do raportu",
  totalDaysContract: "Całkowita ilość dni kontraktu",
  toUser: "użytkownikowi",
  toZone: "dla rejonizacji",
  trackAll: "Śledź wszystkie",
  trophies: "Trofea",
  trophy: "Trofeum",
  trophy0RankDescription: "Brak osiągnięć ECO.",
  trophy1RankDescription: "Przejechano 100 km z oceną wyższą niż 6.00.",
  trophy2RankDescription: "Przejechano 1 000 km z oceną wyższą niż 6.00.",
  trophy3RankDescription: "Przejechano 5 000 km z oceną wyższą niż 6.50.",
  trophy4RankDescription: "Przejechano 10 000 km z oceną wyższą niż 6.50.",
  trophy5RankDescription: "Przejechano 30 000 km z oceną wyższą niż 7.00.",
  trophy6RankDescription: "Przejechano 50 000 km z oceną wyższą niż 8.00.",
  trophyTopRating: "Ranking doświadczenia ECO",
  tuesday: "Wtorek",
  turnedOn: "Włączony",
  turnedOff: "Wyłączony",
  turnOn: "Włączyć",
  turnOnAutomaticContractNumeration: "Włączenie automatycznej numeracji umowy",
  turnOff: "Wyłączyć",
  turnOffBlockMode: "Wyłącz blokade auta",
  turnOnBlockMode: "Włącz blokade auta",
  turnOffPanicMode: "Wyłącz tryb panic",
  turnOnPanicMode: "Włącz tryb panic",
  turnOffServiceMode: "Wyłącz tryb serwisowy",
  turnOnServiceMode: "Włącz tryb serwisowy",
  turnOnServiceInfo: "Wysłanie polecenia może trwać nawet do 5 minut. W przypadku gdyby akacja nie skończyła się po tym czasie, proszę skontaktować się z administratorem systemu.",
  turnOnServiceWaring: "Jeśli samochód jest w statusie ‚rozłączony lub rozłączony+’ znaczy to że: „Auto znajduje się poza zasięgiem GSM GPRS”. W związku z tym polecenie może zostać nie wykonane. Czy chcesz kontynuować?",
  type: "Typ",
  type2: "Rodzaj",
  unableToFindAddressWithoutLocation: "Nie można znaleźć adresu bez znanej lokalizacji",
  unableToFindRoute: "Nie znaleziono elementu do zaznaczenia.",
  unauthorizedError: "Brak autoryzacji",
  unexpectedError: "Nieoczekiwany błąd...",
  understand: "Rozumiem",
  undoChanges: "Cofnij zmiany",
  unknownLocation: "Lokalizacja nieznana",
  unoccupied: "Wolny",
  updateData: "Zaktualizuj dane",
  uploadFile: "Prześlij plik",
  user: "Użytkownik",
  userAccount: "Konto użytkownika",
  userAccountExpiredNotification: "Konto użytkownika wygasło. Skontaktuj się z administratorem systemu",
  userBlockedNotification: "Konto użytkownika zablokowane. Skontaktuj się z administratorem systemu",
  userDeleted: "Użytkownik usunięty",
  username: "Nazwa użytkownika",
  usernameHasBeenChanged: "Imię i nazwisko zostały zmienione",
  usernameLabel: "Użytkownik",
  users: "Użytkownicy",
  userAccountType: "Typ konta użytkownika",
  utf8FileInformation: "Przesyłany plik musi być w formacie UTF-8!, (nagłówek pozostaw)",
  userType: "Typ konta",
  source: 'Źródło',
  vehicleArchived: "Pojazd zarchiwizowany",
  vinNo: "Nr VIN",
  warningTriangle: "Trójkąt",
  wednesday: "Środa",
  week: "Tydzień",
  weekly: "tygodniowy",
  weekly1: "tygodniowe",
  weeklyReportTitle: "Tygodniowych",
  willCauseRemoveAllTrophiesFromTheBase: "Spowoduje to usunięcie wszystkich zebranych trofeów.",
  willCauseStartCollectingTrophiesByDrivers: "Spowoduje to zbieranie trofeów przez kierowców, na podstawie ich jazdy.",
  workSchedule: "Dni i godziny pracy",
  workStartTime: "Czas rozpoczęcia pracy",
  workFinishTime: "Czas zakończenia pracy",
  workingHoursHasBeenUpdated: "Godziny pracy zaktualizowane",
  worst: "Najgorsze",
  worstCars: "najgorsze auta",
  yearOfContract: "Umowa rok",
  zipCode: "Kod Pocztowy",
  zonesUpdateSuccessMessage: "Dopuszczalne rejony dla wybranych aut zaktualizowane",
  zoning: "Rejonizacja",
  zoningTitle: "Rejonizacja samochodu",
  zoningWhileLending: "Rejonizacja podczas użyczenia"
};
